import AutocompleteItem from '../components/AutocompleteItem.vue';
import stations from '../data/stations';

export const autocomplete = {
  data () {
    return {
      autocompleteData: stations,
      items: [],
      item: null,
      AutocompleteItemTemplate: AutocompleteItem,
    }
  },
  methods: {
    updateItems (text) {
      this.items  = this.autocompleteData.filter((item) => {
        return item.name.replace(/[.,']/g,"").toLowerCase().includes(text.replace(/[.,']/g,"").toLowerCase())
      }).sort((a, b) => a.name.indexOf(text) < b.name.indexOf(text) ? -1 : 1 );

      if (this.items.length == 1 && text.toLowerCase() === this.items[0].name.toLowerCase()) {
        this.item = this.items[0];
        this.itemSelected(this.item);
      }      
    },
    getLabel (item) {
      if (item) {
        return item.name
      }
      return ''
    }
  }
}


// WEBPACK FOOTER //
// ./src/mixins/autocomplete.js